<div class="modal-wrapper">
  <ion-header class="ion-no-border premium-header">
    <div class="header-curve"></div>
    <div class="custom-toolbar">
      <div class="toolbar-content">
        <div class="icon-btn" (click)="close()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </div>
        <div class="title-group">
          <div class="title-main">Vincular a Cotización</div>
          <div class="title-sub">Asignación de Ítem OC</div>
        </div>
      </div>
    </div>
  </ion-header>

  <ion-content class="modal-content" [scrollY]="true">

    <div class="layout-wrapper">
      <div class="steps-container">
        <div class="step-indicator" [class.active]="currentStep >= 1">1</div>
        <div class="step-line" [class.active]="currentStep >= 2"></div>
        <div class="step-indicator" [class.active]="currentStep >= 2">2</div>
        <div class="step-line" [class.active]="currentStep >= 3"></div>
        <div class="step-indicator" [class.active]="currentStep >= 3">3</div>
      </div>

      <div class="slides-container">

        <!-- STEP 1: SELECT COTIZACION -->
        <div class="slide-section" *ngIf="currentStep === 1">
          <div class="slide-header">
            <h3>Seleccionar Cotización</h3>
            <p>Elige la cotización a vincular</p>
          </div>

          <!-- OC Item Summary Card with Multi-OC Selection -->
          <div class="form-card summary-card">
            <div class="summary-header-row">
              <div class="summary-icon">
                <ion-icon name="document-text-outline"></ion-icon>
              </div>
              <div class="summary-info">
                <span class="oc-label">Documento OC</span>
                <span class="oc-number">{{ ocItem?.numero_documento }}</span>
              </div>
              <div class="summary-badge-group" *ngIf="hasMultipleOcItems">
                <ion-chip class="group-toggle-chip" [color]="showOcItemsSelector ? 'danger' : 'medium'" (click)="showOcItemsSelector = !showOcItemsSelector">
                  <ion-icon [name]="showOcItemsSelector ? 'chevron-up-outline' : 'layers-outline'"></ion-icon>
                  <ion-label>{{ selectedOcItemsCount }} de {{ selectableOcItems.length }} ítems OC</ion-label>
                </ion-chip>
              </div>
            </div>

            <!-- Single Item Header (si no está desplegado el selector) -->
            <div class="summary-body" *ngIf="!showOcItemsSelector">
              <h2 class="item-desc">#{{ ocItem?.item }}: {{ ocItem?.descripcion }}</h2>
              <div class="monto-pills-row">
                <div class="item-monto-pill" [class.grouped-pill]="selectedOcItemsCount > 1">
                  <ion-icon name="cash-outline"></ion-icon>
                  <span>{{ selectedOcItemsCount > 1 ? 'Total OC Agrupado (' + selectedOcItemsCount + ' ítems):' : 'Monto OC:' }} {{ totalOcSelectedAmount | currency:'USD' }}</span>
                </div>
                <button *ngIf="hasMultipleOcItems" type="button" class="btn-link-more" (click)="showOcItemsSelector = true">
                  <ion-icon name="add-circle-outline"></ion-icon>
                  <span>+ Agrupar otros ítems</span>
                </button>
              </div>
            </div>

            <!-- Multi-OC Items Selector Accordion -->
            <div class="multi-oc-selector-box" *ngIf="showOcItemsSelector">
              <div class="multi-oc-header">
                <div class="multi-oc-title">
                  <ion-icon name="layers-outline"></ion-icon>
                  <span>Seleccionar ítems de esta OC para combinar montos:</span>
                </div>
                <button type="button" class="btn-close-selector" (click)="showOcItemsSelector = false">
                  <ion-icon name="checkmark-circle-outline"></ion-icon> Listo
                </button>
              </div>

              <div class="multi-oc-items-list">
                <div *ngFor="let itm of selectableOcItems" class="multi-oc-item-row" [class.selected]="itm.selected" [class.is-current]="itm.isCurrent" (click)="toggleOcItemSelection(itm, $event)">
                  <ion-checkbox [checked]="itm.selected" [disabled]="itm.isCurrent" (click)="$event.stopPropagation()" (ionChange)="toggleOcItemSelection(itm)"></ion-checkbox>
                  <div class="multi-oc-item-info">
                    <div class="multi-oc-item-top">
                      <div class="num-wrapper">
                        <span class="multi-oc-item-num">#{{ itm.item }}</span>
                        <span *ngIf="itm.isCurrent" class="current-badge">Origen</span>
                      </div>
                      <span class="multi-oc-item-amount">{{ itm.importe_neto | currency:'USD' }}</span>
                    </div>
                    <div class="multi-oc-item-desc">{{ itm.descripcion }}</div>
                  </div>
                </div>
              </div>

              <div class="multi-oc-total-bar">
                <span>Total combinado OC:</span>
                <strong>{{ totalOcSelectedAmount | currency:'USD' }}</strong>
              </div>
            </div>
          </div>

          <!-- Search & Filters -->
          <div *ngIf="!isAlreadyLinked" class="search-filter-container">
            <ion-searchbar class="premium-searchbar" placeholder="Buscar cotización o cliente..." [(ngModel)]="searchQuery"
              (ionInput)="searchCotizacion($event)"></ion-searchbar>
            
            <div class="filter-controls">
              <ion-chip [outline]="!onlyMatchAmount" [color]="onlyMatchAmount ? 'danger' : 'medium'" (click)="toggleAmountFilter()">
                <ion-icon name="cash-outline"></ion-icon>
                <ion-label>Misma cantidad (OC: {{ totalOcSelectedAmount | currency:'USD' }})</ion-label>
              </ion-chip>
            </div>
          </div>

          <!-- Already Linked Banner -->
          <div *ngIf="isAlreadyLinked" class="already-linked-banner">
            <ion-icon name="information-circle-outline"></ion-icon>
            <div class="banner-text">
              <h3>Ítem ya vinculado</h3>
              <p>Este ítem de OC ya está relacionado con la cotización mostrada abajo. Para cambiar la vinculación, primero debes desvincularla.</p>
            </div>
            <ion-button fill="clear" color="danger" (click)="desvincular()" [disabled]="saving">
              <ion-icon name="link-outline" slot="start"></ion-icon>
              Desvincular
            </ion-button>
          </div>

          <!-- Loading -->
          <div *ngIf="loadingCotizaciones" class="loading-state">
            <ion-spinner name="crescent" color="danger"></ion-spinner>
            <p>Cargando cotizaciones...</p>
          </div>

          <!-- Cotizaciones List -->
          <div *ngIf="!loadingCotizaciones && filteredCotizaciones.length > 0" class="form-card list-card">
            <ion-radio-group [(ngModel)]="selectedCotizacionId">
              <div class="scrollable-list">
                <div *ngFor="let cot of filteredCotizaciones" class="cot-item"
                     [class.linked-item]="cot.isDisabled && !isAlreadyLinked"
                     [class.priority-item]="cot.isPriority && !isAlreadyLinked"
                     [class.selected-item]="selectedCotizacionId === cot.id">
                  <ion-radio [value]="cot.id" color="danger" [disabled]="cot.isDisabled && !isAlreadyLinked"></ion-radio>
                  <div class="cot-body">
                    <div class="cot-header" style="display: flex; justify-content: space-between; align-items: center;">
                      <div>
                        <span class="id-badge">#{{ cot.id }}</span>
                        <span class="cot-total">{{ cot.subtotal | currency:'USD' }}</span>
                      </div>
                      <div style="pointer-events: auto;">
                        <!-- Notice the use of button wrapping -->
                        <ion-button *ngIf="cot.isDisabled && !isAlreadyLinked && (!ocItem.memos || ocItem.memos.length === 0)" fill="clear" size="small" color="primary" (click)="registerMemo($event, cot)" style="--padding-end: 5px; --padding-start: 0; height: 24px;">
                          <ion-icon name="bookmark-outline" slot="icon-only"></ion-icon>
                        </ion-button>

                        <ion-button fill="clear" size="small" color="medium" (click)="previewCotizacion($event, cot)" style="--padding-end: 0; --padding-start: 0; height: 24px;">
                          <ion-icon name="information-circle-outline" slot="icon-only"></ion-icon>
                        </ion-button>
                      </div>
                    </div>
                    
                    <!-- Status message from logic -->
                    <div class="status-badge" *ngIf="cot.statusMessage && !isAlreadyLinked" 
                         [class.success]="cot.isFullyLinked" [class.warning]="!cot.isFullyLinked && !cot.isInvoiced" [class.danger]="cot.isInvoiced">
                      {{ cot.statusMessage }}
                    </div>

                    <div class="status-pill warning" *ngIf="!cot.isFullyLinked && Math.abs(cot.subtotal - totalOcSelectedAmount) > 0.01">
                      <span class="status-dot"></span>
                      <span class="status-text">Monto Distinto</span>
                    </div>
                    <div class="status-pill success" *ngIf="!cot.isFullyLinked && Math.abs(cot.subtotal - totalOcSelectedAmount) <= 0.01">
                      <span class="status-dot"></span>
                      <span class="status-text">Monto Coincide</span>
                    </div>
                    
                    <p class="cliente-name">{{ cot.cliente }}</p>
                    <div class="direccion-info" *ngIf="cot.direccion">
                      <ion-icon name="location-outline"></ion-icon>
                      <span>{{ cot.direccion }}</span>
                    </div>
                    <p class="desc-text">{{ cot.descripcion || 'Sin descripción' }}</p>
                  </div>
                </div>
              </div>
            </ion-radio-group>
          </div>
        </div>

        <!-- STEP 2: SELECT TYPE AND ITEMS -->
        <div class="slide-section" *ngIf="currentStep === 2">
          <div class="slide-header">
            <h3>Tipo de Vinculación</h3>
            <p>Define cómo vincular la cotización</p>
          </div>

          <!-- Selected Cotizacion Summary -->
          <div class="form-card selection-summary">
            <div class="summary-icon-sm">
              <ion-icon name="document-text-outline"></ion-icon>
            </div>
            <div class="summary-detail">
              <span class="id-label">COTIZACIÓN SELECCIONADA</span>
              <strong>#{{ selectedCotizacion?.id }}</strong>
              <div class="dir-label" *ngIf="selectedCotizacion?.direccion">
                <ion-icon name="location-outline"></ion-icon>
                <span>{{ selectedCotizacion?.direccion }}</span>
              </div>
              <p class="summary-desc">{{ selectedCotizacion?.descripcion || 'Sin descripción' }}</p>
            </div>
          </div>

          <!-- Type Selector -->
          <div class="form-card">
            <div class="card-section-title">
              <ion-icon name="options-outline"></ion-icon>
              <span>Método de Vinculación</span>
            </div>
            <ion-radio-group [(ngModel)]="linkType">
              <div class="type-card" [class.selected]="linkType === 'general'" (click)="linkType = 'general'">
                <ion-radio value="general" color="danger"></ion-radio>
                <div class="type-info">
                  <h2>Cotización Completa</h2>
                  <p>Vincular el monto neto de la cotización ($ {{ selectedCotizacion?.subtotal }})</p>
                </div>
              </div>
              <div class="type-card" [class.selected]="linkType === 'specific'" (click)="linkType = 'specific'">
                <ion-radio value="specific" color="danger"></ion-radio>
                <div class="type-info">
                  <h2>Ítems Específicos</h2>
                  <p>Seleccionar solo algunos ítems de esta cotización</p>
                </div>
              </div>
            </ion-radio-group>
          </div>

          <!-- Specific Items List -->
          <div *ngIf="linkType === 'specific'" class="form-card">
            <div class="card-section-title">
              <ion-icon name="list-outline"></ion-icon>
              <span>Ítems de Cotización</span>
            </div>

            <div *ngIf="loadingItems" class="loading-state compact">
              <ion-spinner name="dots" color="danger"></ion-spinner>
            </div>

            <div *ngIf="!loadingItems && cotizacionItems.length > 0" class="items-container">
              <div *ngFor="let item of cotizacionItems" class="detail-item">
                <div class="item-content">
                  <div class="item-header">
                    <span class="item-ref">Ítem #{{ item.id }}</span>
                    <span class="item-total">{{ (item.precio * item.cantidad) | currency:'USD' }}</span>
                  </div>
                  <h3 class="premium-desc">{{ item.descripcion }}</h3>
                  <p class="item-meta">Cantidad: {{ item.cantidad }} | Precio: {{ item.precio | currency:'USD' }}</p>
                </div>
                <ion-toggle [(ngModel)]="item.selected" color="danger"></ion-toggle>
              </div>
            </div>
          </div>
        </div>

        <!-- STEP 3: FINAL VALIDATION -->
        <div class="slide-section" *ngIf="currentStep === 3">
          <div class="slide-header">
            <h3>Resumen Final</h3>
            <p>Verifica los datos antes de confirmar</p>
          </div>

          <div class="form-card validation-card">
            <div class="val-header">
              <ion-icon [name]="isValidAmount ? 'checkmark-circle' : 'warning'"
                [color]="isValidAmount ? 'success' : 'danger'"></ion-icon>
              <h3>Resumen de Vinculación</h3>
            </div>

            <!-- Desglose de ítems OC si hay múltiples -->
            <div class="oc-items-breakdown" *ngIf="selectedOcItemsCount > 1">
              <span class="breakdown-title">Ítems de OC seleccionados ({{ selectedOcItemsCount }}):</span>
              <div class="breakdown-list">
                <div *ngFor="let itm of selectedOcItemsList" class="breakdown-row">
                  <span>#{{ itm.item }}: {{ itm.descripcion }}</span>
                  <strong>{{ itm.importe_neto | currency:'USD' }}</strong>
                </div>
              </div>
            </div>

            <div class="comparison-grid">
              <div class="comp-box">
                <span>{{ selectedOcItemsCount > 1 ? 'Total Ítems OC' : 'Monto OC Item' }}</span>
                <div class="amount">{{ totalOcSelectedAmount | currency:'USD' }}</div>
              </div>
              <div class="comp-icon"><ion-icon name="swap-horizontal-outline"></ion-icon></div>
              <div class="comp-box">
                <span>Monto a Vincular</span>
                <div class="amount" [class.err]="!isValidAmount">{{ selectedLinkTotal | currency:'USD' }}</div>
              </div>
            </div>

            <div class="val-message" [class.error]="!isValidAmount">
              <p *ngIf="isValidAmount">
                <ion-icon name="checkmark-done-circle" color="success"></ion-icon>
                ¡Listo! Los montos coinciden perfectamente.
              </p>
              <p *ngIf="!isValidAmount">
                <ion-icon name="close-circle" color="danger"></ion-icon>
                <strong>Diferencia detectada:</strong> {{ amountDiffValue | currency:'USD' }} ({{ amountDiffMessage }}).
                El monto vinculado debe ser exactamente {{ totalOcSelectedAmount | currency:'USD' }}.
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>

  </ion-content>

  <div class="form-footer-actions">
    <!-- Back Button -->
    <ion-button *ngIf="currentStep > 1" (click)="prevStep()" fill="outline" class="cancel-modal-btn">
      <ion-icon name="arrow-back-outline" slot="start"></ion-icon>
      Atrás
    </ion-button>

    <!-- Next / Confirm Button -->
    <ion-button *ngIf="currentStep < 3" (click)="nextStep()" class="save-btn"
      [disabled]="currentStep === 1 && !selectedCotizacionId">
      <span>Siguiente</span>
      <ion-icon name="arrow-forward-outline" slot="end"></ion-icon>
    </ion-button>

    <ion-button *ngIf="currentStep === 3" (click)="saveLink()" class="save-btn"
      [disabled]="saving || !isValidAmount">
      <ion-spinner *ngIf="saving" name="crescent" color="light" slot="start"></ion-spinner>
      <span *ngIf="!saving">Confirmar y Vincular</span>
      <ion-icon *ngIf="!saving" name="checkmark-done-outline" slot="end"></ion-icon>
    </ion-button>
  </div>
</div>
